module.exports = __webpack_public_path__ + "PTSans-NarrowBold.415a37cc8ed4f13df4c4.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/PTSans-NarrowBold.woff
// module id = ../../../../../src/assets/customfonts/PTSans-NarrowBold.woff
// module chunks = styles